export const DecorativeBorder = ({ top = false }) => (
  <div aria-hidden="true" className={`w-full relative pt-4 pb-4 flex items-center ${top ? '' : 'rotate-180'}`}>
    <div className="w-[5px] h-[5px] bg-darkGold rounded-full"></div>
    <div className="w-full h-px bg-darkGold"></div>
    <div className="w-[5px] h-[5px] bg-darkGold rounded-full"></div>
    <div className="w-px h-4 bg-darkGold absolute left-1/2 -translate-x-1/2 -translate-y-1/2"></div>
    <div className="w-[5px] h-[5px] bg-darkGold rounded-full absolute left-1/2 -translate-x-1/2 -translate-y-4"></div>
  </div>
);
